import { gql } from '@apollo/client';

export const IS_FEATURE_FLAG_ENABLED = gql`
  query IsFeatureFlagEnabled($featureName: String!) {
    isFeatureFlagEnabled(featureName: $featureName)
  }
`;

export const IS_FEATURE_FLAG_ENABLED_FOR_ORG = gql`
  query IsFeatureFlagEnabledForOrg($featureName: String!, $organizationId: MongoObjectId!) {
    isFeatureFlagEnabledForOrg(featureName: $featureName, organizationId: $organizationId)
  }
`;

export const FETCH_FEATURE_FLAGS_BY_NAME = gql`
  query FetchFeatureFlagsByName($featureName: String!) {
    fetchFeatureFlagsByName(featureName: $featureName) {
      _id
      featureName
      whitelist {
        users
        userRoles
        organizations
      }
      createdBy {
        _id
        firstName
        lastName
      }
      updatedBy {
        _id
        firstName
        lastName
      }
      status
      description
    }
  }
`;

export const ENABLED_FEATURE_FLAGS = gql`
  query EnabledFeatureFlags($enabledFeatureFlagsInput: EnabledFeatureFlagsInput) {
    enabledFeatureFlags(enabledFeatureFlagsInput: $enabledFeatureFlagsInput)
  }
`;

export const FEATURE_FLAG_UPDATED = gql`
  subscription {
    featureFlagUpdated
  }
`;
